import styles from '../SpendingLimitDrawer.module.css';
import { UnavailableLimit } from './UnavailableLimit';
import { SpendingLimits } from '../../Dashboard.types';
import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';

export const ValidLimitDrawer = ({
    spendingLimits
}: {
    spendingLimits: SpendingLimits;
}) => {
    return (
        <>
            <div className={styles.spendingLimits}>
                {Object.keys(spendingLimits.limits).map((key) => {
                    const spendingLimit =
                        spendingLimits.limits[
                            key as keyof typeof spendingLimits.limits
                        ];

                    if (!spendingLimit)
                        return (
                            <UnavailableLimit
                                sellerProduct={
                                    key as keyof typeof spendingLimits.limits
                                }
                                key={key}
                            />
                        );

                    return (
                        <div key={key}>
                            <div className={styles.loanDuration}>
                                {spendingLimit.durationInMonths} months
                                purchases
                            </div>
                            <div className={styles.leftToSpend}>
                                Left to spend:
                            </div>
                            <div className={styles.creditLimitContainer}>
                                <FormattedCurrency
                                    className={styles.creditLimit}
                                    value={spendingLimit.creditLimit}
                                />
                            </div>

                            <div className={styles.interestRate}>
                                {(spendingLimit.interestRate * 100).toFixed(2)}
                                %/month or interest-free**
                            </div>
                            <div className={styles.maxLimit}>
                                Limit:{' '}
                                <FormattedCurrency
                                    value={spendingLimit.maxCreditLimit}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
            <div className={styles.footer}>
                <div>
                    *Your spending limits are subject to approval and reassessed
                    every 30 days - if something changes with your business the
                    amounts might change.
                </div>
                <div>**Interest-free is offered by some of our suppliers.</div>
            </div>
        </>
    );
};
